import { TableRating } from '@shared/types/floorPlans';
import { api } from '../../api';
import type {
  DailyPriceForecast,
  DayOfWeekOccupancyRating,
  ListingWithPrices,
  MonthRating,
  TemporalListingPriceCandidate,
  TemporalOccupancyRatings,
  TimeOfDayOccupancyRating,
} from './types';

export const getTemporalListingPrices = async (
  restaurantId: string,
  date: string,
) => {
  const params = new URLSearchParams({ date });
  return api.get<ListingWithPrices[]>(
    `/restaurants/${restaurantId}/temporal-listing-prices?${params.toString()}`,
  );
};

export const getTemporalListingPriceForecast = async (
  restaurantId: string,
  startDate: string,
  endDate: string,
) => {
  const params = new URLSearchParams({ startDate, endDate });
  return api.get<DailyPriceForecast[]>(
    `/restaurants/${restaurantId}/temporal-listing-prices/forecast?${params.toString()}`,
  );
};

export const getTemporalOccupancyRatings = async (restaurantId: string) =>
  api.get<TemporalOccupancyRatings>(
    `/restaurants/${restaurantId}/temporal-occupancy-ratings`,
  );

export interface UpdateTemporalOccupancyRatingsPayload {
  timeOfDayOccupancyRatings: Omit<TimeOfDayOccupancyRating, 'id'>[];
  dayOfWeekOccupancyRatings: Omit<DayOfWeekOccupancyRating, 'id'>[];
  monthOfYearOccupancyRatings: MonthRating[];
}

export const updateTemporalOccupancyRatings = (
  restaurantId: string,
  payload: UpdateTemporalOccupancyRatingsPayload,
) =>
  api.post<void>(
    `/restaurants/${restaurantId}/temporal-occupancy-ratings`,
    payload,
  );

export const upsertTemporalListingPrices = (
  restaurantId: string,
  payload: {
    temporalListingPrices: TemporalListingPriceCandidate[];
    neutralizationThreshold: number;
    minPriceThreshold: number;
  },
) =>
  api.put<void>(
    `/restaurants/${restaurantId}/temporal-listing-prices`,
    payload,
  );

export interface FloorPlanTableUpdate {
  id: string;
  rating: TableRating;
}

export const updateFloorPlanTables = async (
  restaurantId: string,
  floorPlanTableUpdates: FloorPlanTableUpdate[],
) => {
  return api.put<void>(
    `/restaurants/${restaurantId}/floor-plan-tables`,
    floorPlanTableUpdates,
  );
};
